import React, { useEffect, useState } from 'react';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { getFinance } from '../api';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend);



// ChartJS registration must happen at the top level, before any other code

const Finance: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getFinance()
      .then(setData)
      .catch(() => setError('Failed to load finance data'));
  }, []);

  if (error) return <div>{error}</div>;
  if (!data) return <div>Loading...</div>;

  const revenueTrend = [12000, 13500, 14000, 15500, 17000, 16500, 18000];
  const spendBreakdown = [8000, 2500, 1200, 800];
  const spendLabels = ['Payroll', 'Cloud', 'Marketing', 'Other'];
  const profitMargin = [20, 22, 21, 23, 24, 25, 26];

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <h2>Finance</h2>
      <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', marginBottom: 32 }}>
        <div style={{ flex: 2, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Revenue Trend</h3>
          <Line
            data={{
              labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
              datasets: [{
                label: 'Revenue',
                data: revenueTrend,
                borderColor: '#43a047',
                backgroundColor: 'rgba(67,160,71,0.08)',
                fill: true,
                tension: 0.4,
              }],
            }}
            options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: false } } }}
            height={180}
          />
        </div>
        <div style={{ flex: 1, minWidth: 320, background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24 }}>
          <h3>Spend Breakdown</h3>
          <Doughnut
            data={{
              labels: spendLabels,
              datasets: [{
                data: spendBreakdown,
                backgroundColor: ['#3949ab', '#43a047', '#ffa000', '#e53935'],
              }],
            }}
            options={{ plugins: { legend: { display: true } } }}
            height={180}
          />
        </div>
      </div>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', padding: 24, marginBottom: 32 }}>
        <h3>Profit Margin (%)</h3>
        <Bar
          data={{
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
            datasets: [{
              label: 'Profit Margin',
              data: profitMargin,
              backgroundColor: '#ffa000',
            }],
          }}
          options={{ plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, max: 30 } } }}
          height={120}
        />
      </div>
      <div>
        <h2>Key Metrics</h2>
        <div><strong>MRR:</strong> ${data.mrr.toLocaleString()}</div>
        <div><strong>ARR:</strong> ${data.arr.toLocaleString()}</div>
        <div><strong>Burn Rate:</strong> ${data.burnRate.toLocaleString()}</div>
        <div><strong>Runway (months):</strong> {data.runwayMonths}</div>
        <div><strong>Recent Expenses:</strong>
          <ul>{data.recentExpenses.map((e: any, i: number) => <li key={i}>{e.name}: ${e.amount.toLocaleString()}</li>)}</ul>
        </div>
      </div>
    </div>
  );
};

export default Finance;
